import { __decorate, __metadata } from "tslib";
import { CacheActivePromise } from '../decorators';
import { lazyAppContext } from '../lazy';
import { appendStyle } from '../lit-utils';
const CALLBACK_NAME = '__turnstile_callback__';
const CONTAINER_ID = 'turnstile-container';
const MAX_RETRY_COUNT = 4;
export class TurnstileController {
    constructor() {
        this.context = lazyAppContext('TurnstileController');
        this.script = null;
    }
    async init(context) {
        this.context.set(context);
    }
    async getToken() {
        await this.initScript();
        const container = this.renderContainer();
        return await this.renderToken(container);
    }
    async initScript() {
        if (this.script)
            return;
        return await new Promise((resolve) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.defer = true;
            script.src = `https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=${CALLBACK_NAME}`;
            Reflect.set(window, CALLBACK_NAME, resolve);
            document.head.appendChild(script);
        });
    }
    renderContainer() {
        const container = document.createElement('div');
        appendStyle(container, {
            position: 'absolute',
            zIndex: '-1',
            top: '-1000px',
            left: '-1000px',
        });
        container.id = CONTAINER_ID;
        document.body.appendChild(container);
        return container;
    }
    async renderToken(container) {
        const siteKey = this.context.value.environment.get('cloudflareTurnstileSiteKey') ?? null;
        if (!siteKey)
            throw new Error('TurnstileController.renderToken Error: siteKey is not defined');
        return await new Promise((resolve, reject) => {
            if (!window.turnstile)
                throw new Error('TurnstileController.renderToken Error: window.turnstile is defined');
            let retryCount = 0;
            const errorHandler = (err) => {
                if (retryCount >= MAX_RETRY_COUNT || !isSupportRetryError(err)) {
                    reject(err);
                    return;
                }
                window.turnstile.reset(`#${CONTAINER_ID}`);
                retryCount++;
            };
            const callback = (token) => {
                try {
                    window.turnstile.remove(`#${CONTAINER_ID}`);
                }
                catch (error) {
                    console.error(error);
                }
                resolve(token);
            };
            window.turnstile.render(container, {
                sitekey: siteKey,
                callback,
                'error-callback': errorHandler,
            });
        });
    }
}
__decorate([
    CacheActivePromise(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], TurnstileController.prototype, "getToken", null);
const TurnstileRetry = ['crashed', 'undefined_error', 'challenge_failed'];
// https://developers.cloudflare.com/turnstile/troubleshooting/client-side-errors/error-codes/#error-code-300-and-600
const TurnstileRetryCode = [102, 103, 104, 106, 300, 600];
function isSupportRetryError(error) {
    if (TurnstileRetry.includes(error)) {
        return true;
    }
    const errorCore = parseInt(error.slice(0, 3), 10);
    if (isNaN(errorCore))
        return false;
    return TurnstileRetryCode.includes(errorCore);
}
//# sourceMappingURL=turnstile.controller.js.map